import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faQuestion } from '@fortawesome/free-solid-svg-icons';
import clicksound from '../components/music/click.mp3';

const ButtonInfo = ({ onClick }) => {
    // Function to play click sound
    const handleClick = (event) => {
        const audio = new Audio(clicksound);
        audio.play();
        
        if (onClick) {
            onClick(event);
        }
    };

    return (
        <button 
            className="info-button lg:w-14 lg:h-14 sm:w-10 sm:h-10" 
            onClick={handleClick}
        >
            <FontAwesomeIcon icon={faQuestion} className='sm:text-xl font-bold lg:text-2xl'/>
        </button>
    );
};

export default ButtonInfo;